import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { AdvisorAssistantList } from "web_myplann/Advisor/Components/AdvisorAssistantList";
import type { AgentAssistantResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";
import { useOpenAgentChat } from "web_myplann/Shared/Hooks/useOpenAgentChat";
import { getAgentChatTitle } from "web_myplann/Shared/Utils/getAgentChatTitle";

type Props = {
	advisorUid: string;
	assistants: AgentAssistantResponseDTO[];
};

export const AdvisorAssistantsSection: FC<Props> = ({
	advisorUid,
	assistants,
}) => {
	const { t } = useResource();
	const navigate = useNavigate();
	const openChat = useOpenAgentChat();

	return (
		<>
			<SectionHeader title={t(Resources.Advisor.assistantsHeading)} />
			<AdvisorAssistantList
				assistants={assistants}
				onOpenChat={(assistant) =>
					openChat({
						uid: assistant.uid,
						title: getAgentChatTitle(assistant),
						conversationId: assistant.conversationId,
					})
				}
				onOpenDetail={({ uid }) =>
					navigate(Routing.AdvisorAssistant.path(uid, advisorUid))
				}
			/>
		</>
	);
};
